export default function loadView(viewPath) {
  return () => import(`@/views/${viewPath}.vue`);
}